import {isCountryAt, isCountryNl} from './utilities/country.mjs';

const configDe = {
  currentCountyCode: 'DE',
  imageDirectoryPath: '',
  svgDirectoryPath: '',
  googleMapsApiKey: '',
};

const configAt = {
  currentCountyCode: 'AT',
};

const configNl = {
  currentCountyCode: 'NL',
};

const config = (() => {
  let tempConfig = {};

  // window.EfConfig is declared as inline-script in project/Configuration/TypoScript/Setup/page.typoscript
  if (window.EfConfig) {
    tempConfig = Object.assign({}, configDe, window.EfConfig);
  }

  if (isCountryAt) {
    tempConfig =  Object.assign({}, tempConfig, configAt);
  }

  if (isCountryNl) {
    tempConfig =  Object.assign({}, tempConfig, configNl);
  }

  return tempConfig;
})();

export default config;
